import FastMarquee from "react-fast-marquee";
import { motion } from "framer-motion";

const Marquee = () => {
  const clients = [
    { name: "Vizra Tech", id: 1 },
    { name: "Selcom Tanzania", id: 2 },
    { name: "1000X", id: 3 },
    { name: "TwoWords", id: 4 },
    { name: "Softareo", id: 5 },
    { name: "Eurocoustic Products", id: 6 },
  ];

  return (
    <section className="py-16 border-y border-white/5 bg-black/20">
      <motion.div
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
      >
        <p className="text-center text-sm font-medium text-white/40 tracking-wider uppercase mb-10">
          Trusted by innovative brands
        </p>

        <FastMarquee
          speed={40}
          gradient={true}
          gradientColor="#0A0A0A"
          gradientWidth={100}
          className="overflow-hidden"
          data-testid="client-marquee"
        >
          {clients.map((client) => (
            <div
              key={client.id}
              className="mx-12 flex items-center justify-center"
              data-testid={`client-${client.id}`}
            >
              <span className="text-2xl md:text-3xl font-['Syne'] font-bold text-white/20 hover:text-white/50 transition-colors duration-300 tracking-tight">
                {client.name}
              </span>
            </div>
          ))}
        </FastMarquee>

        <FastMarquee
          speed={40}
          direction="right"
          gradient={true}
          gradientColor="#0A0A0A"
          gradientWidth={100}
          className="overflow-hidden mt-8"
        >
          {clients.reverse().map((client) => (
            <div
              key={`reverse-${client.id}`}
              className="mx-12 flex items-center justify-center"
            >
              <span className="text-2xl md:text-3xl font-['Syne'] font-bold text-white/20 hover:text-white/50 transition-colors duration-300 tracking-tight">
                {client.name}
              </span>
            </div>
          ))}
        </FastMarquee>
      </motion.div>
    </section>
  );
};

export default Marquee;
